<template>
  <div>
    <h3>Register User</h3>

    <vx-card no-shadow class="mt-8">
      <h2 class="mb-6">User Information</h2>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>First Name</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input class="w-full" v-model="firstName" placeholder="First name..." />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Last Name</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input class="w-full" v-model="lastName" placeholder="Last name..." />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>SSN</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input class="w-full" v-model="ssn" placeholder="Social Security Number..." />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Email</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input class="w-full" v-model="email" placeholder="Email..." />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Phone</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full" style="display:flex;align-items: flex-end;">
          <vs-select class="mt-2" v-model="selectedPhoneCountryCode">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in phoneCountryCodes" />
          </vs-select>

          <vs-input v-validate="'numeric'" name="phone" v-model="phone" placeholder="Phone..." class="w-full ml-2" />
        </div>
      </div>

      <div class="vx-row  mb-6">
        <div class="vx-col sm:w-1/5 w-full">
        </div>
        <div class="vx-col sm:w-2/5 w-full" style="display:flex;align-items: flex-end;">
          <div class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first('phone') }}</div>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Job Title</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input class="w-full" v-model="jobTitle" placeholder="Job title..." />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Role</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <div class="horizontal-row">
            <vs-button
              v-for="(role) in roles"
              :key="role.id"
              @click="selectedRole = role.id"
              :color="selectedRole == role.id ? 'success' : 'rgb(80, 80, 80)'"
              :type="selectedRole == role.id ? 'filled' : 'border'"
              icon-pack="feather"
              :icon="selectedRole == role.id ? 'icon-check' : ''"
              class="mr-3 selection-button"
            >{{role.label}}</vs-button>
          </div>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>App Invitation</span>
        </div>
        <div class="vx-col sm:w-3/5 w-full">
          <vs-checkbox v-model="sendAppInvitation">Invite User to REKOM LIFE App?</vs-checkbox>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <textarea
            class="vs-inputx vs-input--input normal"
            style="height:200px;font-family: Arial;line-height: 1.5rem;"
            spellcheck="false"
            v-model="appInvitationMessage"
            placeholder="Invitation Message"
            :disabled="!sendAppInvitation"
          />
        </div>
      </div>
    </vx-card>

    <!-- Register User Button -->
    <div class="flex flex-wrap items-center justify-end mt-12">
      <vs-button
        @click="registerUser"
        id="save-button"
        class="ml-auto mr-auto mt-2"
        size="large"
      >Register</vs-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // User information
      firstName: '',
      lastName: '',
      ssn: '',
      email: '',
      jobTitle: '',
      
      selectedRole: 0,
      roles: [
        {
          id: 0,
          label: "User"
        },
        {
          id: 1,
          label: 'Admin'
        }
      ],

      phone: null,
      phoneCountryCodes:[
        { text:'Denmark (+45)', value: '+45' },
        { text:'Sweden (+46)', value: '+46' },
        { text:'Norway (+47)', value: '+47' },
        { text:'UK (+44)', value: '+44' },
        { text:'Finland (+358)', value: '+358' }
      ],
      selectedPhoneCountryCode: '+45',

      sendAppInvitation: true,
      appInvitationMessage: ''
    };
  },
  methods: {
    registerUser: function() {
      this.$vs.loading()

      const payload = {
        firstName: this.firstName,
        lastName: this.lastName,

        ssn: this.ssn,

        email: this.email,
        
        phone: this.phone,
        phoneCountryCode: this.selectedPhoneCountryCode,

        jobTitle: this.jobTitle,

        role: this.selectedRole,

        sendAppInvitation: this.sendAppInvitation,
        appInvitationMessage: this.appInvitationMessage
      };

      this.$http.post(process.env.VUE_APP_API +'/users', payload)
        .then(resp => {
          console.log(resp.data);

          if (resp.data.hasUserErrors === false) {
            if (resp.data.hasInviteErrors === false) {
              this.$vs.notify({
                color:'success',
                title:'Success',
                text:'User added'
              });
            } else {
              this.$vs.notify({
                color:'warning',
                title:'Warning',
                text:'User added, but sending invitation failed'
              });
            }
            this.$router.push({ name: 'admin-users' }).catch(() => {})
          } else {
            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not add user: ' + resp.data.errors
            });
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    }
  },
  created() {
  }
};
</script>

<style lang="scss" scoped>
.horizontal-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
</style>